// extracted by mini-css-extract-plugin
export default {"root":"Devices_root__MQoXc"};